import { render } from "./AddSeedNavComponent.vue?vue&type=template&id=e48c4574&scoped=true"
import script from "./AddSeedNavComponent.vue?vue&type=script&lang=js"
export * from "./AddSeedNavComponent.vue?vue&type=script&lang=js"

import "./AddSeedNavComponent.vue?vue&type=style&index=0&id=e48c4574&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src794593303/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/viracocha-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48c4574"]])

export default __exports__